import { DateTime } from 'luxon';

import { Role } from './MembershipRole';

class Invitation {
  public readonly id: string;
  public readonly email: string;
  public readonly roles: Role[];
  public readonly expiresAt: DateTime;
  constructor({ id, email, roles, expiresAt }: { id: string; email: string; roles: Role[]; expiresAt: DateTime }) {
    this.id = id;
    this.email = email;
    this.roles = roles;
    this.expiresAt = expiresAt;
  }

  public static fromJSON = (value: any) => {
    const { id, email, roles, expiresAt } = Object.assign({}, value);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof email !== 'string') throw new TypeError('.email must be a string');
    if (typeof roles !== 'object') throw new TypeError('.email must be a object');
    const e = DateTime.fromISO(expiresAt);
    if (!e.isValid) throw new TypeError('.expiresAt must be a valid date string');

    return new Invitation({
      id,
      email,
      roles: roles.map((role: any) => role as Role),
      expiresAt: e,
    });
  };
}

export default Invitation;
